import { graphql } from '@search/gql-client/src';

export const userEmailsQuery = graphql`
  query UserEmailsQuery {
    userEmails {
      emailsList
      primaryEmail
    }
  }
`;
